import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=37de7c10&scoped=true&"
import script from "./PageError.vue?vue&type=script&lang=ts&"
export * from "./PageError.vue?vue&type=script&lang=ts&"
import style0 from "./PageError.vue?vue&type=style&index=0&id=37de7c10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de7c10",
  null
  
)

export default component.exports